<template>
  <div>
    <div class="row" v-for="(item, index) in form.inspecaoPeriodo" :key="index">
      <div v-if="!item.excluir" class="col-12">
        <div class="row tempo-borda">
          <div class="col-2 form-group">
            <label>*Limit:</label>
            <input type="number" class="form-control form-control-sm"
              :class="{ 'is-invalid': errors.has('limit ' + (index + 1)) }" :name="'limit ' + (index + 1)"
              v-validate="'required'" v-model="item.limit" @input="item.limit = $event.target.value.toUpperCase()"
              :disabled="visualizar" min="0" step=".01" />
            <span class="invalid-feedback" v-show="errors.has('limit ' + (index + 1))">{{ errors.first("limit " + (index +
              1)) }}</span>
          </div>

          <div class="col-2 form-group">
            <label>*Unit:</label>
            <select class="form-control form-control-sm" :class="{ 'is-invalid': errors.has('unit ' + (index + 1)) }"
              :name="'unit ' + (index + 1)" v-validate="'required'" v-model="item.unit" v-on:change="selectionChanged(item)" :disabled="visualizar">
              <option :value="null">ESCOLHA</option>
              <option v-for="itemUnits in units" :key="itemUnits" :value="itemUnits">
                {{ itemUnits }}
              </option>
            </select>
            <span class="invalid-feedback" v-show="errors.has('unit ' + (index + 1))">{{ errors.first("unit " + (index +
              1)) }}</span>
          </div>

          <div class="col-2 form-group">
            <label>Margin:</label>
            <input type="number" class="form-control form-control-sm" v-model="item.margin"
              @input="item.margin = $event.target.value.toUpperCase()" :disabled="visualizar" min="0" step=".01" />
          </div>

          <div class="col-2 form-group">
            <label>Margin Unit:</label>
            <select v-model="item.marginUnit" :disabled="visualizar" class="form-control form-control-sm">
              <option :value="null">ESCOLHA</option>
              <option v-for="itemUnits in units" :key="itemUnits" :value="itemUnits">
                {{ itemUnits }}
              </option>
            </select>
          </div>

          <div class="col-2 form-group">
            <label>Provisional:</label>
            <select v-model="item.provisional" :disabled="visualizar" class="form-control form-control-sm">
              <option :value="null">ESCOLHA</option>
              <option :value="true">SIM</option>
              <option :value="false">NÃO</option>
            </select>
          </div>

          <div v-if="item.calendarico" class="col-2 form-group">
            <label>Counter:</label>
            <select v-model="item.fs" :disabled="visualizar" class="form-control form-control-sm">
              <option :value="null">ESCOLHA</option>
              <option v-for="itemFs in fsN" :value="itemFs">
                {{ itemFs }}
              </option>
            </select>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-4 form-group">
                <label>PN:</label>
                <div class="input-group">
                  <input class="form-control form-control-sm" v-model="item.pn"
                    @input="item.pn = $event.target.value.toUpperCase()" />
                  <span class="input-group-append">
                    <button class="btn btn-sm btn-outline-primary" type="button" :disabled="item.pn.trim() == ''"
                      @click="adicionarPN(index)">
                      <fa-icon icon="plus"></fa-icon> ADICIONAR
                    </button>
                  </span>
                </div>
              </div>

              <div class="col-8">
                <label>Adicionados:</label><br />
                <span v-for="(itemAdicionados, indexAdicionados) in item.pnPeriodo" v-show="!itemAdicionados.excluir"
                  :key="indexAdicionados">
                  <span class="badges badge-primary badge-pn" v-if="!itemAdicionados.excluir">
                    {{ itemAdicionados.descricao }}
                    <span class="float-right" style="cursor: pointer; margin-left: 10px" v-if="!visualizar"
                      @click="removerPN(index, indexAdicionados)">
                      <fa-icon icon="times" title="Clique para remover"></fa-icon>
                    </span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="col-12 mb-2 pb-1">
            <button class="float-left btn btn-danger btn-sm" title="Clique para remover" v-if="!visualizar"
              @click.prevent="removerPeriodo(index)">
              <fa-icon icon="times"></fa-icon> REMOVER PERIODICIDADE
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-sm btn-outline-primary" type="button" @click="adicionarPeriodo" v-if="!visualizar">
          <fa-icon icon="plus"></fa-icon> ADICIONAR PERIODICIDADE
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["inspecaoPeriodo", "visualizar", "fs"],

  data() {
    return {
      units: [
        "FH",
        "M",
        "HC",
        "SC",
        "OPH",
        "ED",
        "BFF",
        "ALF",
        "INF",
        "D",
        "TA",
        "OPC",
        "TC",
        "C(N1)",
        "C(N2)",
        "C(NP)",
        "P",
        "LC",
        "LHC",
        "REF",
        "L",
      ],

      form: {
        inspecaoPeriodo: this.inspecaoPeriodo,
      },

      arrayLength: 0,

      fsN:['TSI', 'TSN']

    };
  },

  methods: {
    removerPeriodo(index) {
      this.arrayLength--
      if (this.form.inspecaoPeriodo[index].id != 0) {
        this.form.inspecaoPeriodo[index].excluir = true;
      } else {
        this.form.inspecaoPeriodo.splice(index, 1);
      }
    },

    selectionChanged(item){
      if(this.form.inspecaoPeriodo[item.id].unit === 'D' || this.form.inspecaoPeriodo[item.id].unit === 'M')
        this.form.inspecaoPeriodo[item.id].calendarico = true
    },

    adicionarPeriodo() {

      this.form.inspecaoPeriodo.push({
        id: this.arrayLength,
        limit: null,
        erroLimit: "",
        unit: null,
        erroUnit: "",
        provisional: null,
        erroProvisional: "",
        fs: null,
        erroFs: "",
        margin: null,
        excluir: false,
        calendarico: false,
        erroMargin: "",
        marginUnit: null,
        erroMarginUnit: "",
        pn: "",
        pnPeriodo: [],
      });
      this.arrayLength++
    },

    adicionarPN(index) {
      this.form.inspecaoPeriodo[index].pnPeriodo.push({
        id: 0,
        descricao: this.form.inspecaoPeriodo[index].pn,
        excluir: false,
      });
    },

    removerPN(index, indexAdicionados) {
      if (
        this.form.inspecaoPeriodo[index].pnPeriodo[indexAdicionados].id != 0
      ) {
        this.form.inspecaoPeriodo[index].pnPeriodo[
          indexAdicionados
        ].excluir = true;
      } else {
        this.form.inspecaoPeriodo[index].pnPeriodo.splice(indexAdicionados, 1);
      }
    },
  },
};
</script>

<style scoped>
.tempo-borda {
  border: 1px solid #ddd;
  margin: 0;
  margin-bottom: 1em;
  padding-top: 0.5em;
  border-radius: 0.2em;
}
</style>



// WEBPACK FOOTER //
// src/views/followair/manutencao/cadastro/inspecao/components/tempos.vue